import React from 'react';
import { formatRoleLabel } from '../utils/permissions';
import { ModalTemplate } from './templates';
import './AccessDeniedModal.css';

/**
 * AccessDeniedModal
 * Shows a brief "you don't have access" message with the user's current roles.
 */
export default function AccessDeniedModal({ roles = [], onClose }) {
  const roleDisplay = (roles || []).length > 0
    ? roles.map(formatRoleLabel).join(', ')
    : 'None';

  return (
    <ModalTemplate
      title="Access Restricted"
      onClose={onClose}
      className="access-denied-modal"
      actions={<button className="btn btn-primary" onClick={onClose}>OK</button>}
    >
      <div className="access-denied-body">
        <div className="access-denied-icon">🔒</div>
        <p className="access-denied-message">
          You do not have access to this part of the web app.
        </p>
        <div className="access-denied-roles">
          <span className="access-denied-roles-label">Roles assigned to you:</span>
          <span className="access-denied-roles-value">{roleDisplay}</span>
        </div>
      </div>
    </ModalTemplate>
  );
}
